import React, { ReactNode, useCallback } from 'react';
import { ContainerCardMeuPlano } from './styles';
import { useMeuPlano } from '../../hooks/useMeuPlano';
import { ScreenMeuPlano } from '../../types/context';

interface CardMeuPlanoProps {
  content: ReactNode;
  screenOpen: ScreenMeuPlano;
  disableClick?: boolean;
}

export const CardMeuPlano: React.FC<CardMeuPlanoProps> = ({
  content,
  screenOpen,
  disableClick = false,
}) => {
  const { isDemonstracao, handleScreen, tipoStatus, refetchContratacaoAtual } =
    useMeuPlano();

  const handleClick = useCallback(async () => {
    if (disableClick) {
      return;
    }

    const isGerenciarAssinatura = screenOpen === 'GERENCIAR-ASSINATURA';
    const isPlanosDisponiveis = screenOpen === 'PLANOS-DISPONIVEIS';
    const isMudarFormaPagamento = screenOpen === 'MUDAR-FORMA-PAGAMENTO';
    const isFaturas = screenOpen === 'FATURAS';

    const isStatusAtivo = tipoStatus.tipoStatus === 2;
    const hasContratacaoTransitoria = Boolean(
      tipoStatus.contratacaoTransitoria,
    );

    if (isDemonstracao) {
      if (isGerenciarAssinatura && !isStatusAtivo) {
        handleScreen('PLANOS-DISPONIVEIS');
        await refetchContratacaoAtual();
        return;
      }

      if (isPlanosDisponiveis || isGerenciarAssinatura) {
        handleScreen(screenOpen);
        await refetchContratacaoAtual();
        return;
      }

      if (
        isMudarFormaPagamento &&
        (isStatusAtivo || hasContratacaoTransitoria)
      ) {
        handleScreen(screenOpen);
        return;
      }

      if (isFaturas && hasContratacaoTransitoria) {
        handleScreen(screenOpen);
        return;
      }

      return;
    }

    if (isPlanosDisponiveis || isGerenciarAssinatura) {
      handleScreen(screenOpen);
      await refetchContratacaoAtual();
      return;
    }

    handleScreen(screenOpen);
  }, [
    disableClick,
    handleScreen,
    isDemonstracao,
    screenOpen,
    tipoStatus.tipoStatus,
    tipoStatus.contratacaoTransitoria,
    refetchContratacaoAtual,
  ]);

  return (
    <ContainerCardMeuPlano
      $disableClick={disableClick}
      onClick={async () => {
        if (!disableClick) {
          await handleClick();
        }
      }}
    >
      {content}
    </ContainerCardMeuPlano>
  );
};
